import { _ as _sfc_main } from "./VaForm.vue_vue_type_script_lang-dee0a35e.mjs";
import { openBlock, createBlock, resolveDynamicComponent, mergeProps, withCtx, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaForm_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), mergeProps({ class: "va-form" }, _ctx.$attrs), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ isValid: _ctx.isValid, validate: _ctx.validate })))
    ]),
    _: 3
  }, 16);
}
const _VaForm = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaForm as _
};

import '../../../VaForm.css';
//# sourceMappingURL=VaForm-c0d195b3.mjs.map
